export function geturl() {
  var url = decodeURIComponent(window.location.href);
  let urlParams = url.split("?")[1];
  let obj = {};
  if (urlParams) {
    let arr = urlParams.split("&");
    for (let i = 0; i < arr.length; i++) {
      let params = arr[i].split("=");
      obj[params[0]] = params[1];
    }
    return obj;
  }
}
